(() => {
  'use strict';
  const guide = document.getElementById('huiliu-app-guide');
  if (!guide) return;
  let installPrompt = null;
  let returnFocus = null;
  const install = guide.querySelector('[data-huiliu-native-install]');
  const done = guide.querySelector('[data-huiliu-installed]');
  const status = guide.querySelector('[data-huiliu-install-status]');
  const messages = guide.querySelector('[data-huiliu-messages]').dataset;
  const deviceActions = guide.querySelector('[data-huiliu-device-actions]');
  const deviceButtons = [...guide.querySelectorAll('[data-huiliu-device]')];
  const iosSteps = guide.querySelector('[data-huiliu-ios]');
  const androidSteps = guide.querySelector('[data-huiliu-android]');
  const ua = navigator.userAgent;
  const ios = /iPhone|iPad|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const android = /Android/.test(ua);
  const inApp = /MicroMessenger|FBAN|FBAV|Instagram|Line\/|BytedanceWebview|TikTok|musical_ly|wv\)/i.test(ua);
  let completed = false;
  let outcome = '';
  let selectedDevice = '';
  const qr = guide.querySelector('[data-huiliu-desktop-qr]');
  const otherPhone = guide.querySelector('[data-huiliu-other-phone]');
  const showSteps = (device, focus = false) => {
    selectedDevice = device;
    iosSteps.open = device === 'ios';
    androidSteps.open = device === 'android';
    deviceButtons.forEach(button => button.setAttribute('aria-expanded', String(button.dataset.huiliuDevice === device)));
    update();
    if (focus) (device === 'ios' ? iosSteps : androidSteps).querySelector('summary').focus();
  };
  const isStandalone = () => window.matchMedia('(display-mode: standalone)').matches || navigator.standalone === true;
  const update = () => {
    const standalone = isStandalone();
    const installed = standalone || completed;
    const needsExternalBrowser = inApp && !installPrompt && !installed;
    document.documentElement.classList.toggle('huiliu-standalone', standalone);
    if (install) install.hidden = installed || !installPrompt;
    if (done) done.hidden = !standalone;
    deviceActions.hidden = installed || needsExternalBrowser || Boolean(installPrompt) || Boolean(selectedDevice);
    iosSteps.hidden = installed || needsExternalBrowser || Boolean(installPrompt) || selectedDevice !== 'ios';
    androidSteps.hidden = installed || needsExternalBrowser || Boolean(installPrompt) || selectedDevice !== 'android';
    qr.hidden = installed || needsExternalBrowser || Boolean(installPrompt) || Boolean(selectedDevice) || ios || android;
    otherPhone.hidden = installed || needsExternalBrowser || Boolean(installPrompt) || !selectedDevice;
    guide.querySelector('[data-huiliu-copy-wrap]').hidden = !needsExternalBrowser;
    guide.querySelector('[data-huiliu-open-chrome]').hidden = !needsExternalBrowser || !android;
    status.textContent = installed ? (standalone ? '' : messages.complete) : installPrompt ? messages.ready : outcome || (inApp ? (android ? messages.inappAndroid : messages.inapp) : selectedDevice === 'ios' ? messages.ios : selectedDevice === 'android' ? messages.android : messages.desktop);
    status.hidden = !status.textContent;
  };
  const open = (trigger) => {
    returnFocus = trigger || document.activeElement;
    if (!guide.open) guide.showModal();
    update();
  };
  document.querySelectorAll('[data-huiliu-install-open]').forEach(button => {
    button.hidden = false;
    button.addEventListener('click', () => {
      open(button);
      if (installPrompt) return requestInstall();
    });
  });
  guide.querySelector('[data-huiliu-install-close]').addEventListener('click', () => guide.close());
  guide.querySelector('[data-huiliu-keep-browsing]').addEventListener('click', () => guide.close());
  deviceButtons.forEach(button => button.addEventListener('click', () => {
    showSteps(button.dataset.huiliuDevice, true);
  }));
  otherPhone.addEventListener('click', () => { selectedDevice = ''; outcome = ''; update(); deviceButtons[0].focus(); });
  [iosSteps, androidSteps].forEach((details, index) => details.addEventListener('toggle', () => {
    deviceButtons[index].setAttribute('aria-expanded', String(details.open));
  }));
  guide.addEventListener('click', event => {
    if (event.target !== guide) return;
    const bounds = guide.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) guide.close();
  });
  guide.addEventListener('close', () => {
    if (returnFocus && document.contains(returnFocus)) returnFocus.focus();
  });
  window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault();
    installPrompt = event;
    outcome = '';
    update();
  });
  window.addEventListener('appinstalled', () => {
    installPrompt = null;
    completed = true;
    update();
  });
  async function requestInstall() {
    if (!installPrompt) return;
    const prompt = installPrompt;
    installPrompt = null;
    install.disabled = true;
    try {
      await prompt.prompt();
      const choice = await prompt.userChoice;
      outcome = choice.outcome === 'accepted' ? messages.accepted : messages.dismissed;
    } catch (_) {
      outcome = android ? messages.android : messages.desktop;
    } finally {
      install.disabled = false;
      update();
    }
  }
  install.addEventListener('click', requestInstall);
  if (ios || android) {
    showSteps(ios ? 'ios' : 'android');
  }
  guide.querySelector('[data-huiliu-copy]').addEventListener('click', async () => {
    const result = guide.querySelector('[data-huiliu-copy-result]');
    try {
      await navigator.clipboard.writeText('https://huiliu-global.com/?huiliu_app=install');
      result.textContent = messages.copied;
    } catch (_) {
      result.textContent = messages.copyFailed + ' https://huiliu-global.com/?huiliu_app=install';
    }
  });
  guide.querySelector('[data-huiliu-open-chrome]').addEventListener('click', () => {
    guide.querySelector('[data-huiliu-copy-result]').textContent = messages.externalHelp;
  });
  if (new URL(window.location.href).searchParams.get('huiliu_app') === 'install') open();
  const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
  document.querySelectorAll('.huiliu-mobile-nav a').forEach(link => {
    const target = new URL(link.href).pathname.replace(/\/$/, '') || '/';
    if (currentPath === target) link.setAttribute('aria-current', 'page');
  });
  update();
  // Position only the cookie-preferences launcher; never change consent or its dialog.
  const positionConsentLauncher = () => {
    const root = document.querySelector('csm-cookie-consent')?.shadowRoot;
    if (!root || root.getElementById('huiliu-launcher-position')) return;
    const style = document.createElement('style');
    style.id = 'huiliu-launcher-position';
    style.textContent = '@media(max-width:749px){div:has(>#reopen_widget){bottom:calc(var(--huiliu-widget-bottom,88px) + env(safe-area-inset-bottom,0px))!important;left:var(--huiliu-widget-left,12px)!important;visibility:var(--huiliu-widget-visibility,visible)!important;pointer-events:var(--huiliu-widget-pointer,auto)!important}}';
    root.appendChild(style);
  };
  positionConsentLauncher();
  const widgetObserver = new MutationObserver(positionConsentLauncher);
  widgetObserver.observe(document.body, {childList:true});
  window.addEventListener('load', positionConsentLauncher, {once:true});
})();
